export default __webpack_public_path__ + "static/multiple-pipelines-filtering-pipelines-kanban-2a5d3620a5ee4bc83d4bcc32b8a73d60.mp4";